import React from 'react';

import { PagesFormProps } from 'views/Pages/types';

import Typography from 'components/Typography/Typography';

import { AddBlock } from './AddBlock';
import { BlocksExport } from './BlocksExport';
import { BlocksImport } from './BlocksImport';
import { BlocksList } from './BlocksList/BlocksList';

const FormHeader: React.FC = () => {
  return (
    <div className="flex flex-col gap-2 mb-5">
      <Typography className="text-base-foreground text-xl font-semibold">
        Edit Your Page Layout
      </Typography>
      <Typography className="text-base-mutedForeground text-sm">
        Add and arrange blocks to customize your page.
      </Typography>
    </div>
  );
};
export const ManageBlocksForm: React.FC<PagesFormProps> = ({
  edit = false,
  dup = false
}) => {
  return (
    <div className="flex flex-col mt-3">
      <FormHeader />
      <div className="flex justify-between mb-8">
        <AddBlock />
        <div className="flex items-center gap-3">
          <BlocksImport />
          <BlocksExport />
        </div>
      </div>
      <BlocksList />
    </div>
  );
};
